//NEW: UI_REVAMP
import { Box, Flex, VStack } from '@chakra-ui/react';
import GradientBox from '../box/GradientBox';
import { BetDetailsCard } from './BetDetailsCard';
import BetResultList from './BetResultList';

export const BetResultImage = ({ results, id = 'bet-result-ticket' }) => {
	return (
		<Box
			position='fixed'
			top='-9999px'
			left='-9999px'
			w='380px'
			h='max-content'
			pointerEvents='none'
		>
			<Flex id={id} flexDirection='column' gap={6} w='full' bg='white' p={4} borderRadius='16px'>
				<GradientBox borderRadius={8} mt={4} mx={3}>
					<BetDetailsCard
						data={results}
						downloadId={id}
						bgGradient='linear-gradient(180deg, #FFF 0%, #E5EDF9 100%), #D6E7FF'
						mb={0}
						borderRadius='inherit'
						isImage={true}
					/>
				</GradientBox>

				<VStack spacing={4} align='stretch'>
					<BetResultList results={results} mx={3} mb={4} noGradient={true} isImage={true} />
				</VStack>
			</Flex>
		</Box>
	);
};
